import * as React from 'react';

export interface MainProps {}

export class Main extends React.Component<MainProps> {
  render() {
    return <div>Hello World</div>;
  }
}
